/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'
import Table from '../../../../components/InternalMenu/JobList'

import ReactPaginate from 'react-paginate'

import jobIcon from '../../../../assets/svg/JobIcon.svg'

import { get } from '../../../../services/http'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  document.title = 'درخواست شغل'

  const [jobs, setJobs] = useState()
  const [jobsCount, setJobsCount] = useState()
  const [totalPage, setTotalPage] = useState()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/im/jobs?token=${token}`)
      .then(response => {
        setJobs(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setJobsCount(response.data.data.total)
      })
      .catch(error => {
        console.log(error)
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/im/jobs?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setJobs(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setJobsCount(response.data.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'job'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={jobIcon} width={'22px'} alt='resturantIcon' />
              </div>
              <div className='text'>
                درخواست شغل
              </div>
            </div>

            <div className="left">
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل درخواست
              </div>
              <div className="left">
                {jobsCount}
              </div>
            </div>

            <Table data={jobs} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
